import React from 'react';
import { useDispatch } from 'react-redux';

import BackButton from '../../shared/BackButton';
import VideoThumbnails from '../helpers/video-thumbnails';
import { setFormData } from '../redux/action';

const ExistingClaim = () => {
  const dispatch = useDispatch();

  return (
    <>
      <BackButton
        analytics={{
          'data-track': 'form-back',
          'data-track-form-name': 'Submit Claim',
          'data-track-form-step': 'step 1 - get started',
        }}
        backText="Get Started"
        onClick={() => dispatch(setFormData({ showExistingClaimPage: false }))}
      />
      <p>
        To add required documents or photos to your claim, please contact us via the chat option at the bottom right of
        your screen or call <strong>1-833-627-7100.</strong> Please have your claim number ready.
      </p>
      <p>Before contacting us, please watch the informative short videos below that explain the claims process.</p>
      <VideoThumbnails show="all" />
    </>
  );
};

export default ExistingClaim;
